import { API_ROOT } from '../../config/config'
import { doGet, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getFinancialReportsDeliveredPage = (projectCode) => {
  const url = `${API_ROOT_VER}/report/financial-delivered/page/${projectCode}`
  return doGet(url)
}

export const downloadFinancialPdf = (projectCode, periodNumber) => {
  // /api/files/{projectCode}/{periodNumber}/financial/form
  const url = `${API_ROOT}/files/${projectCode}/${periodNumber}/financial/form`
  return doDownload(url)
}

export const downloadFinancialExport = (projectCode, periodNumber) => {
  const url = `${API_ROOT}/files/${projectCode}/${periodNumber}/financial/form/excel`
  return doDownload(url)
}
